<template>
  <div class="paid-wrap">
    <!-- <div class="paid-wrap__title">
      <p class="mb-0 bold"><span class="state-ok"></span> {{ title }}</p>
    </div> -->
    <div class="relative">
      <div class="paid" :style="'bottom:' + p + '%' ">
        <strong class="h2">{{ p | formatMoneyInt }} %</strong>
      </div>
      <img :src="obrazek" alt="Zlatý slitek" v-if="obrazek != null">
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        p: 0,
        interval: null
      };
    },
    props: {
      // title: String,
      procento: Number,
      obrazek: String
    },
    mounted () {
      this.p = 0;
      var fn = () => {
        this.$nextTick(() => {
          this.p = this.p + 1;
          if (this.p < this.procento) {
            this.$nextTick(() => {
              setTimeout(fn, 15);
            });
          }
        });
      };
      if (this.procento > 0)
        setTimeout(fn, 10);
    }
  }
</script>
